import React from 'react';
import Prom from '@leverege/promise';
import { Dialog, Dialogs, Flex, Label, Pane, TextInput, Toast } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { Context } from '@leverege/plugin';
import { FilterSourcesModel } from '@leverege/molten/filters';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class BulkFlagDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      progress: 0,
      flag: null
    };
  }
  updateAll = async () => {
    const {
      clientProps: {
        delegate,
        filters
      },
      onClose,
      flag,
      targets
    } = this.props;
    const {
      flag: sFlag
    } = this.state;
    this.setState({
      loading: true
    });
    try {
      if (targets?.length > 0) {
        await Prom.mapLimit(targets, async target => {
          const item = target.data;
          await GlobalState.dispatch(delegate.item(item.path).update([{
            path: `metadata/auditFlag/${flag || sFlag}`,
            value: true
          }]));
          this.setState(({
            progress
          }) => ({
            progress: progress + 1
          }));
        }, {
          limit: 5
        });
      } else {
        const limit = 500;
        let page,
          hasMore,
          offset = 0;
        const filter = FilterSourcesModel.getFilter(filters);
        const sort = FilterSourcesModel.getSort(filters);
        do {
          // eslint-disable-next-line no-await-in-loop
          page = await GlobalState.dispatch(delegate.search({
            limit,
            offset,
            order: sort,
            filter,
            returnSignedUrl: false,
            queryName: 'bulkFlag'
          }));
          // eslint-disable-next-line no-await-in-loop
          await Prom.mapLimit(page?.items, async item => {
            await GlobalState.dispatch(delegate.item(item.path).update([{
              path: `metadata/auditFlag/${flag || sFlag}`,
              value: true
            }]));
            this.setState(({
              progress
            }) => ({
              progress: progress + 1
            }));
          }, {
            limit: 5
          });
          hasMore = limit + offset < page.total;
          offset += limit;
        } while (hasMore);
      }
    } catch (err) {
      console.error(err);
      Toast.error('Error flagging resources');
    }
    this.setState({
      loading: false
    });
    onClose();
    const {
      progress
    } = this.state;
    Toast.success(`successfully flagged ${progress + 1} rsrcs`);
  };
  onKeyDown = e => {
    e.stopPropagation();
  };
  render() {
    const {
      show,
      onClose,
      clientProps: {
        items
      },
      flag,
      targets
    } = this.props;
    const {
      loading,
      progress,
      flag: sFlag
    } = this.state;
    const total = targets?.length > 0 ? targets.length : items.total;
    let message = `This will flag ${total} resources, continue?`,
      children,
      okayDisabled = loading;
    if (!flag) {
      children = /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        onKeyDown: this.onKeyDown,
        children: [/*#__PURE__*/_jsxs(Pane, {
          children: [/*#__PURE__*/_jsx(Label, {
            children: "Flag Name"
          }), /*#__PURE__*/_jsx(TextInput, {
            value: sFlag,
            onChange: ({
              value
            }) => this.setState({
              flag: value
            })
          })]
        }), /*#__PURE__*/_jsx(Pane, {
          children: message
        })]
      });
      message = null;
      okayDisabled = loading || !sFlag;
    }
    if (loading) {
      message = `flagging resource ${progress} of ${total}`;
    }
    return /*#__PURE__*/_jsx(Dialog.Question, {
      title: "Bulk Flag Rsrcs",
      onClose: onClose,
      onOkay: this.updateAll,
      onCancel: onClose,
      show: show,
      cancelDisabled: loading,
      okayDisabled: okayDisabled,
      message: message,
      children: children
    });
  }
}
export default {
  id: 'rsrc.bulkGenericFlag',
  name: 'Generic Flag Resources',
  matches: {
    client: ['GroupScreen', 'rsrc.gallery.RsrcThumbnailRenderer', 'rsrc.gallery.RsrcSelectedDialog'],
    use: ['contextMenu', 'mobileActionBar'],
    objectType: 'rsrc'
  },
  layout: {
    sort: 'zflag.item.bulkFlag',
    sectionName: 'Data Auditing'
  },
  handles: context => {
    const {
      clientProps: {
        items
      }
    } = context;
    const targets = Context.getTargetsOfType(context, 'rsrc');
    return items?.items?.length > 0 || targets?.length > 0;
  },
  appearance: ({
    context
  }) => {
    const targets = Context.getTargetsOfType(context, 'rsrc');
    return {
      name: targets?.length > 0 ? `Generic Flag (${targets.length})` : 'Generic Flag (All Matching Search)',
      icon: 'fa fa-fw fa-flag'
    };
  },
  perform: ({
    context
  }) => {
    // show a dialog that just updates every resource in the list
    const targets = Context.getTargetsOfType(context, 'rsrc');

    // show a dialog that just updates every resource in the list
    Dialogs.show({
      component: BulkFlagDialog,
      props: {
        ...context,
        targets
      }
    });
  }
};